// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { AutocompleteItemModel, BrandAutocompleteModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { Fragment } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

import setIsSearchPage from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetIsSearchPage";

/* Starter Custom Code - Start */
import { autocompleteProps } from "@store/Themes/common/props/autocomplete";
/* Starter Custom Code - End */

interface OwnProps {
    brands: BrandAutocompleteModel[] | null;
    popularBrands?: BrandAutocompleteModel[] | null;
    focusedItem?: AutocompleteItemModel;
    goToUrl: (url: string) => void;
    extendedStyles?: AutocompleteBrandsStyles;
    isRetailSearchCompletionResults?: boolean;
}
type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

const mapDispatchToProps = {
    setIsSearchPage,
};

export interface AutocompleteBrandsStyles {
    headerText?: TypographyPresentationProps;
    subHeaderText?: TypographyPresentationProps;
    brandItemText?: TypographyPresentationProps;
    divider?: InjectableCss;
    focusedBrandItemText?: TypographyPresentationProps;
    link?: LinkPresentationProps;
    focusedLink?: LinkPresentationProps;
    autocompleteBrandsRowWrapper?: InjectableCss;
    autocompleteBrandsColumnWrapper?: InjectableCss;
    // Starter Custom Code
    note?: TypographyPresentationProps;
}

export const autocompleteBrandsStyles: AutocompleteBrandsStyles = {
    headerText: autocompleteProps.headerText,
    autocompleteBrandsColumnWrapper: autocompleteProps.autocompleteColumnWrapper,
    subHeaderText: autocompleteProps.subHeaderText,
    link: autocompleteProps.link,
    focusedLink: autocompleteProps.focusedLink,
    note: autocompleteProps.note,
};

const styles = autocompleteBrandsStyles;

const Divider = styled.hr`
    ${styles.divider?.css}
`;

class AutocompleteBrands extends React.Component<Props> {
    private readonly styles: AutocompleteBrandsStyles;

    constructor(props: Props) {
        super(props);

        this.styles = mergeToNew(styles, props.extendedStyles);
    }

    renderBrands = (brands: BrandAutocompleteModel[]) => {
        const styles = this.styles;
        return (
            <>
                {/* Starter Custom Code - Start */}
                <ul>
                    {brands.map(brand => (
                        <li key={`${brand.id}_${brand.productLineId}`}>
                            <Link
                                {...(this.props.focusedItem === brand ? styles.focusedLink : styles.link)}
                                onClick={() => {
                                    this.props.setIsSearchPage(false);
                                    this.props.goToUrl(brand.url);
                                }}
                                data-test-selector={
                                    brand.productLineName
                                        ? `productLineId_${brand.productLineId}`
                                        : `brandId_${brand.id}`
                                }
                                className="autocomplete-brands-link"
                            >
                                {brand.productLineName ? (
                                    <>
                                        {brand.displayProductLineName}
                                        <Typography {...styles.note} className="autocomplete-brands-note">
                                            <>{` ${translate("in")}`}</> {brand.displayTitle}
                                        </Typography>
                                    </>
                                ) : (
                                    brand.displayTitle
                                )}
                            </Link>
                        </li>
                    ))}
                </ul>
                {/* Starter Custom Code - End */}
            </>
        );
    };

    render() {
        const { brands, popularBrands, isRetailSearchCompletionResults } = this.props;
        if ((!brands || brands.length === 0) && (!popularBrands || popularBrands.length === 0)) {
            return null;
        }

        const styles = this.styles;
        return (
            <>
                <Typography
                    {...styles.headerText}
                    data-test-selector="autocompleteBrands_Header"
                    className="autocomplete-brands-header"
                >
                    {translate("Brands")}
                </Typography>

                {brands && brands.length > 0 && !isRetailSearchCompletionResults && this.renderBrands(brands)}

                {isRetailSearchCompletionResults && (
                    <>
                        {/* Starter Removed - Divider */}
                        {/* Starter Removed - autocompleteBrandsRowWrapper */}
                        {popularBrands && popularBrands.length > 0 && (
                            <StyledWrapper
                                {...this.styles.autocompleteBrandsColumnWrapper}
                                className="autocomplete-brands-column-wrapper"
                            >
                                <Typography
                                    {...styles.subHeaderText}
                                    data-test-selector="autocompleteBrands_subHeader"
                                    className="autocomplete-brands-subheader"
                                >
                                    {translate("popular")}
                                </Typography>
                                {this.renderBrands(popularBrands)}
                            </StyledWrapper>
                        )}
                        {brands && brands.length > 0 && (
                            <StyledWrapper
                                {...this.styles.autocompleteBrandsColumnWrapper}
                                className="autocomplete-brands-column-wrapper"
                            >
                                <Typography
                                    {...styles.subHeaderText}
                                    data-test-selector="autocompleteBrands_subHeader"
                                    className="autocomplete-brands-subheader"
                                >
                                    {translate("suggested")}
                                </Typography>
                                {this.renderBrands(brands)}
                            </StyledWrapper>
                        )}
                    </>
                )}
            </>
        );
    }
}

export default connect(null, mapDispatchToProps)(AutocompleteBrands);
